import { render, staticRenderFns } from "./SqsMessages.vue?vue&type=template&id=088ca54d&scoped=true&"
import script from "./SqsMessages.vue?vue&type=script&lang=js&"
export * from "./SqsMessages.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "088ca54d",
  null
  
)

export default component.exports